import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter, useLocation, useHistory } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";

const CallsMember = () => {
    const history = useHistory();
    const location = useLocation();           
    const [customerCalls, setcustomerCalls] = useState([]);        
    
    useEffect(() => { 
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CallDetails/GetCallByCustomerId/` + location.state)
            .then((response) => {
                setcustomerCalls(response.data);
            }); 
    }, []); 
    
    const toolbarOptions = [
        "Search"
    ];
    const pageSettingsOptions = {
        pageCount: 3, pageSize: 10, pageSizes: [10, 20, 30, 40, 50]
    };       

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <button
                            className="back e-icons e-back e-btn e-flat e-icon-btn"
                            title="Back"
                            onClick={() => history.goBack()}
                        ></button>    
                    </div>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Call History</h3>
                    </div>
                    <div id='grdAdmin'>
                        <strong>{customerCalls[0]?.customerName}</strong>
                        <GridComponent dataSource={customerCalls} allowSorting={true} height='auto'  
                            allowPaging={true} pageSettings={pageSettingsOptions} toolbar={toolbarOptions} >
                            <ColumnsDirective>
                                <ColumnDirective field='callID' headerText='Call Id' textAlign='left' visible={false} />
                                <ColumnDirective field='petID' headerText='Pet Id' textAlign='left' visible={false} />                                                                
                                <ColumnDirective field='petName' headerText='Pet Name' width='150' textAlign='left' />
                                <ColumnDirective field='callDate' headerText='Date' width='120' textAlign='left' type='datetime' format='MM/dd/yyyy' />
                                <ColumnDirective field='startTime' headerText='Start Time' width='130' textAlign='left' />
                                <ColumnDirective field='endTime' headerText='End Time' width='120' textAlign='left' />
                                <ColumnDirective field='notes' headerText='Notes' textAlign='left' />                                
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(CallsMember);